import { faCogs, faUser, faKey, faSignOutAlt } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

export const FaCogs = () => <FontAwesomeIcon icon={faCogs} />
export const FaUser = () => <FontAwesomeIcon icon={faUser} />
export const FaKey = () => <FontAwesomeIcon icon={faKey} />
export const FaSignOutAlt = () => <FontAwesomeIcon icon={faSignOutAlt} />
